/* "Request a quote" under Add to cart on every product page, linking to the
   contact page; the contact form's message box is pre-filled with the product. */
(function () {
  function addQuoteButtons() {
    document.querySelectorAll('[id*="product-information"] .product-form-buttons').forEach(function (buttons) {
      if (buttons.querySelector('.labeq-quote')) return;
      var cart = buttons.querySelector('add-to-cart-component');
      if (!cart) return;
      var slot = cart;
      while (slot.parentElement && slot.parentElement !== buttons) slot = slot.parentElement;
      var heading = document.querySelector('[id*="product-information"] h1');
      var title = (heading ? heading.textContent : document.title).trim();
      var link = document.createElement('a');
      link.className = 'labeq-quote';
      link.textContent = 'Request a quote';
      link.href = '/pages/contact?quote=' + encodeURIComponent(title) +
        '&url=' + encodeURIComponent(location.origin + location.pathname);
      slot.insertAdjacentElement('afterend', link);
    });
  }

  function prefillContactForm() {
    var params = new URLSearchParams(location.search);
    var product = params.get('quote');
    if (!product) return;
    var message = document.querySelector('.contact-form textarea');
    if (!message || message.value) return;
    var url = params.get('url') || '';
    message.value = 'Hi, I would like a quote for:\n' + product + (url ? '\n' + url : '') + '\n\n';
  }

  function run() {
    addQuoteButtons();
    prefillContactForm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // The product form re-renders when a variant changes; put the button back.
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      addQuoteButtons();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
